import { useEffect, useMemo, useRef } from 'react'
import { useSetState } from 'ahooks'
import { Button, Col, Form, Input, message, Row, Select } from 'antd'
import { ExclamationCircleFilled, MinusCircleOutlined } from '@ant-design/icons'
import { SAlert, SFuncModal, SFuncModalFormRef, STitle } from 'shj-components'

import { SpecsConfigure } from './components/SpecsConfigure'
import { SKUConfigure } from './components/SKUConfigure'
import { SKUConfigTable } from './components/SKUConfigTable'
import styles from '../../index.module.less'
import { isEmpty } from 'lodash-es'
import { getArgList, packModelCreateSkuByArgs, packModelSkuSave } from '@/services/product.ts'
import { useParams } from 'react-router-dom'

const StepQuotaSpecs = props => {
  const { editRef, cacheId, setStep, baseInfo, setBaseInfo } = props
  const { id } = useParams()
  const [form] = Form.useForm()
  const specsFormRef = useRef<any[]>([])
  const skuFormRef = useRef<any[]>([])
  const specsRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const skuRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const [state, setState] = useSetState<any>({
    specsFormItemList: [],
    SKUConfigure: [],
    dataSource: [],
    loading: false,
    isRelProd: false,
  })

  // ref赋值 因为取不到最新状态值
  useEffect(() => {
    specsFormRef.current = state.specsFormItemList
  }, [state.specsFormItemList])

  useEffect(() => {
    skuFormRef.current = state.SKUConfigure
  }, [state.SKUConfigure])

  const isShowSKUConfigure = useMemo(() => {
    return state.SKUConfigure?.some(item => item.data?.length > 1)
  }, [state.SKUConfigure])

  useEffect(() => {
    setStep(state.SKUConfigure, state.specsFormItemList)
  }, [state.SKUConfigure, state.specsFormItemList])

  useEffect(() => {
    // console.log(id, cacheId, 'step2---->')
    getInfo()
  }, [baseInfo])

  const getInfo = async () => {
    console.log(baseInfo, 'baseInfo步骤2')
    const list = await getArgList({ enabled: true })
    if (!id && !baseInfo?.specificationArgList?.length) {
      const formData = {}
      const data = list
        .filter(item => {
          if (item.argCode === 'budgetType') {
            formData['budgetType'] = []
            return item
          }
        })
        .map(item => ({
          ...item,
          label: item.argName,
          value: item.argCode,
          type: item.argType,
          data: [],
          options: item.argValueJson?.list?.map(spe => ({
            ...spe,
            label: spe.name,
            value: spe.id || spe.name,
          })),
        }))
      console.log('add----->', data, formData)
      setState({ SKUConfigure: data, specsFormItemList: data })
      form.setFieldsValue(formData)
    } else if (id) {
      console.log(baseInfo, 'baseInfo步骤2')
      const formData = {}
      const data =
        baseInfo.specificationArgList?.map(item => {
          const current = list.find(arg => arg.argCode === item.argCode) || {}
          formData[item.argCode] =
            item.argType === 'CHOOSE'
              ? item.values.map(i => i.valueId || i.valueCode || i.name)
              : ''
          return {
            ...item,
            label: item.argName,
            value: item.argCode,
            type: item.argType,
            options: current.argValueJson?.list || [], // 原始下拉选择数据
          }
        }) || []
      handleSpecs(data, true)
      setState({ SKUConfigure: data?.filter(item => item.type === 'CHOOSE') })
      form.setFieldsValue(formData)
      setState({ dataSource: baseInfo.skuList || [], specsFormItemList: data })
    }
  }

  const onAddSpecs = () => {
    SFuncModal({
      title: '添加规格',
      formRef: specsRef.current,
      content: (
        <SpecsConfigure
          selectedFormRows={state.specsFormItemList}
          formRef={specsRef}
          fn={handleSpecs}
        />
      ),
    })
  }

  const handleSpecs = (data = [], init = false) => {
    const formItems = data?.reduce((res, item: any) => {
      const data: any[] = []
      item.values?.forEach(i => {
        data.push({ ...i, label: i.valueName, value: i.valueId || i.id || i.name })
      })
      if (item.argType === 'CHOOSE') {
        const delList = item.argValueJson?.list.map(spe => ({
          ...spe,
          label: spe.name,
          value: spe.id,
        }))
        item.data = [...data]
        item.options = [...delList]
      }
      res.push(item)
      return res
    }, [])
    setState({ specsFormItemList: [...state.specsFormItemList, ...formItems] })
    !init && state.dataSource?.length && setState({ dataSource: [] })
  }

  // 修改规格配置（多选下拉框规格）
  const onChangeConfigure = current => {
    form.setFieldValue(current.value, current.data)
    const obj = {}
    let newData: any[] = []
    const record = skuFormRef.current.find(item => item.value === current.value)
    if (record) {
      record.data = current.data
      newData = skuFormRef.current
    } else {
      newData = [...skuFormRef.current, current].reduce((res, item) => {
        !obj[item.value] && (obj[item.value] = res.push(item))
        return res
      }, [])
    }
    const newSpecs = state.specsFormItemList.map(item => {
      if (item.argCode === current.argCode) {
        item.data = current.data
      }
      return item
    })
    setState({ SKUConfigure: [...newData], specsFormItemList: newSpecs })
    current.type === 'CHOOSE' && state.dataSource?.length && setState({ dataSource: [] })
  }

  // 删除规格配置
  const onDelConfigure = current => {
    form.resetFields([current.value])
    const newData: any[] = []
    specsFormRef.current.forEach(item => {
      if (item.value !== current.value) newData.push(item)
    })
    if (current.type === 'CHOOSE') {
      const SKUConfigure = skuFormRef.current.filter(item => item.value !== current.value)
      setState({ SKUConfigure })
    }
    setState({ specsFormItemList: newData })
    state.dataSource?.length && setState({ dataSource: [] })
  }

  const onAddConfigure = () => {
    SFuncModal({
      title: '添加配置',
      formRef: skuRef.current,
      content: <SKUConfigure config={state.SKUConfigure} formRef={skuRef} fn={getSku} />,
    })
  }

  const getSku = (formData?, isHave?) => {
    setState({ loading: true })
    const values = form.getFieldsValue()
    const keys = Object.keys(values)
    let argList = []
    const list = [...state.specsFormItemList].map(item => {
      item.data = item.data?.map(i => {
        return {
          ...i,
          valueName: i.name || i.label,
          valueId: i.id || i.value,
        }
      })
      if (keys.includes(item.argCode)) {
        let obj: any = {}
        let val = item.argType === 'CHOOSE' ? [...item.data] : []
        if (formData) {
          val = formData[item.argCode]
            ? item.data.filter(el => formData[item.argCode].includes(el.value))
            : []
        }
        obj.id = item.id
        obj.argCode = item.argCode
        obj.argType = item.argType
        obj.argName = item.argName
        obj.values = val
        argList.push(obj)
      }
      return item
    })
    console.log('getSku--->', argList)
    return packModelCreateSkuByArgs({
      spuName: baseInfo.modelName,
      [isHave ? '' : 'argList']: argList,
    })
      .then((res: any) => {
        console.log(res, 'res')
        console.log(list, 'list')
        setState({ dataSource: res.skuList || [], specsFormItemList: list })
        return res || []
      })
      .finally(() => setState({ loading: false }))
  }

  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then(async values => {
          if (!state.dataSource.length) return message.error('请添加SKU配置！')
          props.setLoading?.(true)
          console.log('finish--->', state.specsFormItemList)
          let dataOne: any = {}
          let hasBudgetArea = false
          state.dataSource?.forEach((item: any) => {
            item?.inputArgList?.forEach((arg: any) => {
              if (arg.argCode === 'BUDGET_AREA') {
                hasBudgetArea = true
              }
            })
          })
          if (!hasBudgetArea) {
            message.error('没有sku配置报价面积，请注意确认')
          }
          if (!isEmpty(state.specsFormItemList)) {
            try {
              // if (!isShowSKUConfigure) dataOne = await getSku()
              let specificationArgList =
                state.specsFormItemList?.map(item => {
                  let values = item.data?.map(el => {
                    return {
                      valueId: el.valueId || el.value,
                      valueName: el.valueName || el.name,
                    }
                  })
                  return {
                    ...item,
                    argId: item.id,
                    values: values,
                  }
                }) || []
              console.log(dataOne, 'dataOne')
              console.log(state, 'state')
              resolve({
                specificationArgList: specificationArgList,
                skuList: state.dataSource,
              })
            } catch (e) {
              reject()
            }
          } else {
            resolve({})
          }
        })
        .catch(error => {
          error.errorFields.length && reject(error)
        })
    })
  }

  if (editRef) {
    editRef.onFinish = onFinish
  }

  return (
    <>
      <div className={styles.edit_wrap}>
        <SAlert type="info">
          已进行SKU设置后，若修改规格，会影响SKU配置和SKU打包，请谨慎操作，修改后，请检查SKU设置和SKU打包
        </SAlert>
        <STitle title={'规格配置'} />
        <Button
          type={'primary'}
          style={{ margin: '10px 10px 10px 0' }}
          onClick={onAddSpecs}
          disabled={state.isRelProd || baseInfo.linkStatus > 0}
        >
          添加规格
        </Button>
        <Form form={form} layout={'vertical'}>
          <Row>
            {state.specsFormItemList.map(item => (
              <Col key={item.value} span={8}>
                <Form.Item label={item.label} required={true} key={item.value}>
                  <Form.Item
                    name={item.value}
                    rules={[
                      {
                        required: item.type === 'CHOOSE',
                        message: `${item.label}不能为空`,
                      },
                    ]}
                    noStyle
                  >
                    {item.type === 'CHOOSE' ? (
                      <Select
                        allowClear
                        style={{ width: '90%' }}
                        mode={'multiple'}
                        disabled={state.isRelProd || baseInfo.linkStatus > 0}
                        placeholder={`请选择${item.label}`}
                        options={item.options}
                        onChange={(data, option) =>
                          onChangeConfigure({
                            ...item,
                            data: option,
                          })
                        }
                      />
                    ) : (
                      <Input
                        style={{ width: '90%' }}
                        placeholder={`值由用户输入`}
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  {item.argCode !== 'budgetType' ? (
                    state.isRelProd || baseInfo.linkStatus ? null : (
                      <MinusCircleOutlined
                        style={{ marginLeft: 10 }}
                        onClick={() => onDelConfigure(item)}
                      />
                    )
                  ) : null}
                </Form.Item>
              </Col>
            ))}
          </Row>
        </Form>
        {
          <>
            <STitle title={'SKU设置'} />
            <Button
              type={'primary'}
              style={{ margin: '10px 10px 0 0' }}
              onClick={onAddConfigure}
              disabled={state.isRelProd || baseInfo.linkStatus > 0}
            >
              添加配置
            </Button>
          </>
        }
      </div>
      {
        <div style={{ marginTop: -15 }}>
          <SKUConfigTable
            columnsConfig={state.specsFormItemList}
            loading={state.loading}
            data={state.dataSource}
            setState={setState}
          />
        </div>
      }
    </>
  )
}

export default StepQuotaSpecs
